import React, {useEffect} from 'react';
import {List, Button, Dropdown, Menu} from 'antd';
import AppScrollbar from '../AppScrollbar';
import IntlMessages from '../../utility/IntlMessages';
import NotificationItem from './NotificationItem';
import './index.style.less';
import {IoIosNotificationsOutline} from 'react-icons/io';
import {
  useNotifications,
  useNotificationsActions,
} from '../../../utility/hooks/NotificationsHooks';
import {
  EVENT_NEW_TS_ORDER,
  EVENT_UPDATE_NOTIFICATIONS,
  offEvent,
  onEvent,
} from '../../../utility/events';

const AppNotifications = () => {
  const {notifications, notViewedCount} = useNotifications();
  const {fetchNotifications} = useNotificationsActions();
  const updateNotifications = React.useCallback(() => fetchNotifications(), []);
  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    onEvent(EVENT_NEW_TS_ORDER, updateNotifications);

    return () => {
      offEvent(EVENT_NEW_TS_ORDER, updateNotifications);
    };
  }, []);

  useEffect(() => {
    onEvent(EVENT_UPDATE_NOTIFICATIONS, updateNotifications);

    return () => {
      offEvent(EVENT_UPDATE_NOTIFICATIONS, updateNotifications);
    };
  }, []);

  const notificationsPreview = notifications.data.slice(0, 10);

  const menu = (
    <Menu className='notify-header-message'>
      <Menu.Item className='header'>
        <IntlMessages id='common.notifications' />({notifications.total})
      </Menu.Item>
      <Menu.Item>
        <AppScrollbar className='notify-scroll-submenu'>
          <List
            className='notify-list'
            dataSource={notificationsPreview}
            renderItem={(item) => {
              return <NotificationItem key={item.id} item={item} />;
            }}
          />
        </AppScrollbar>
      </Menu.Item>
      <Menu.Item>
        <Button type='primary' className='notify-btn-all' href={`/notifications`}>
          <IntlMessages id='common.viewAll' />
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} className='dropdown' trigger={['click']}>
      <a className='notify-link' onClick={(e) => e.preventDefault()}>
        {notViewedCount > 0 && (
          <span className={'notify-new'}>{notViewedCount}</span>
        )}
        <span className='notify-icon'>
          <IoIosNotificationsOutline />
        </span>
        <span className='notify-text'>
          <IntlMessages id='common.notifications' />
        </span>
      </a>
    </Dropdown>
  );
};

export default AppNotifications;
